import { useTranslation } from "react-i18next";

import DateTime from "components/DateTime";
import { getFirstLetterUppercase } from "shared/functions";
import { DateType } from "shared/types/types";

import SingleDataItem from "../../SingleDataItem";
import { TASK_ATTRIBUTES } from "../../types/enums";
import { SingleAttributeProps } from "../types";
import VehicleData from "./VehicleData";

const SingleAttribute = ({ keyName, value }: SingleAttributeProps) => {
    const { t } = useTranslation();

    const isDate = keyName === TASK_ATTRIBUTES.Date;
    const isVehicleId = keyName === TASK_ATTRIBUTES.VehicleId;

    const capitalizedKeyName = getFirstLetterUppercase(keyName);
    const name = t(`Attributes##${capitalizedKeyName}`);

    const translatedAttribute = (attr: string | number) =>
        t(`Attributes##${attr}`, { defaultValue: attr });

    const getMessage = () => {
        if (isDate) {
            return <DateTime date={value as DateType} format="L" />;
        }

        const renderValue = () => {
            if (Array.isArray(value)) {
                const translatedValues = value.map(item =>
                    translatedAttribute(item)
                );

                return translatedValues.length > 0
                    ? translatedValues.join(", ")
                    : "-";
            }

            if (value === null || value === undefined || value === "") {
                return "-";
            }

            return translatedAttribute(value);
        };

        return renderValue();
    };

    const message = getMessage();

    const renderVehicleData = isVehicleId && typeof value === "number";

    return renderVehicleData ? (
        <VehicleData id={value} />
    ) : (
        <SingleDataItem name={name} data={message} />
    );
};

export default SingleAttribute;
